import {NativeCallbacks} from "./Callbacks";
import Native from "./Native";

/**
 * A photo manager that uses no actual camera.
 *
 * Used for web versions of the games.
 *
 * This class is available via WebPhotoManager as a singleton.
 *
 */
class HTMLPhotoManager {

    private _urls = {};

    constructor() {

    }

    addPhoto(albumName: string, url: string, index: number) {
        if(!this._urls[albumName]) {
            this._urls[albumName] = [];
        }
        if(index >= 0 && index < this._urls[albumName].length) {
            this._urls[albumName][index] = url;
        } else {
            this._urls[albumName].push(url);
        }
    }

    deletePhoto(albumName: string, idx: number) {
        this._urls[albumName][idx] = null;
        // trim array
        this._urls[albumName] = this._urls[albumName].filter((x) => x != null);
        NativeCallbacks.fireCallback(Native.CB_DELETE_PHOTO, {idx: idx});
    }

    retrievePhotoUrls(albumName: string) {
        NativeCallbacks.fireCallback(Native.CB_GET_PHOTO_URLS, {urls: this._urls[albumName] || []});
    }

}

let WebPhotoManager = new HTMLPhotoManager();
export {WebPhotoManager};



// WEBPACK FOOTER //
// ../lib/src/HTMLPhotoManager.ts